export const resolveDescription = (description, runtimeName) => typeof description === 'function' ? description(runtimeName) : description;
export const assertAvailable = (name, availability, runtime) => {
    if (!availability.includes(runtime)) {
        throw new Error(`Tool "${name}" is not available in the ${runtime} runtime`);
    }
};
//# sourceMappingURL=toolDefinitionUtils.js.map